"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _createBreakpoints = _interopRequireDefault(require("@material-ui/core/styles/createBreakpoints"));

var _button2 = _interopRequireDefault(require("./classes/button"));

var _checkbox = _interopRequireDefault(require("./classes/checkbox"));

var _switch = _interopRequireDefault(require("./classes/switch"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var breakpoints = (0, _createBreakpoints["default"])({});
var muiTheme = (0, _core.createMuiTheme)({
  overrides: {
    MuiButton: _button2["default"],
    MuiCheckbox: _checkbox["default"],
    MuiSwitch: _switch["default"]
  },
  palette: {
    primary: {
      main: '#ffffff'
    },
    secondary: {
      main: '#ffffff'
    }
  },
  typography: {
    fontFamily: "Helvetica Neue, 'Helvetica', Arial, sans-serif",
    // fontFamily: "Futura",
    // fontFamily: 'Menlo, Monaco, Consolas, Courier New, monospace",
    fontSize: 16,
    // Mapped to NCSS Headlines eg: NCSS .headline-1 = h1
    h1: {
      fontSize: '2rem',
      fontWeight: 600,
      lineHeight: 1.167
    },
    h2: {
      fontSize: '1.75rem',
      fontWeight: 500,
      lineHeight: 1.2
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 400,
      lineHeight: 1.2
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 400,
      lineHeight: 1.235
    },
    h5: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: 1.334
    },
    // Mapped to NCSS Body eg: NCSS .body-1 = subtitle1
    subtitle1: {
      fontSize: '1.25rem' // 20px

    },
    subtitle2: {
      fontSize: '1rem'
    },
    // Mapped to NCSS body eg: NCSS body-1 = body1
    body1: {
      fontSize: '0.875rem' // 14px

    },
    body2: {
      fontSize: '0.875rem'
    },
    button: _defineProperty({
      textTransform: 'none'
    }, breakpoints.down('sm'), {
      textTransform: 'uppercase'
    })
  }
}); // module.exports = muiTheme;

var _default = muiTheme;
exports["default"] = _default;
